import { colors } from "@mui/material";
import TableCellRate from "./TableCellRate";


const TableCellRateSubtotalPerPlan = ({ computedRates, planName, currency, specificCurrency, fractionDigits = 2, isLoading = false, bgColor = colors.grey[100], style }) => {
  
  function computeSubtotal() {
    if (computedRates == null) { return; }

    if (specificCurrency && specificCurrency !== currency) {
      return '-';
    }

    let subTotal = 0;

    for (let i = 0; i < computedRates.length; i++) {
      if (isNaN(computedRates?.[i]?.[planName])) {
        return 0;
      }

      subTotal += computedRates?.[i]?.[planName];
    }

    return subTotal;
  }

  return (
    <TableCellRate 
      rate={computeSubtotal()}
      currency={currency}
      fractionDigits={fractionDigits}
      isLoading={isLoading}
      bgColor={bgColor}
      style={style}
    />
  );
};

export default TableCellRateSubtotalPerPlan;